import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/common/ui/alert-dialog";

interface DeleteFlagDialogProps {
  flagKey: string | null;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteFlagDialog({
  flagKey,
  open,
  onConfirm,
  onCancel,
}: DeleteFlagDialogProps): React.ReactElement {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent data-testid="delete-flag-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete flag &ldquo;{flagKey}&rdquo;?</AlertDialogTitle>
          <AlertDialogDescription>
            This will permanently delete the flag and all its targeting rules. Any code referencing
            this flag will receive the default value. This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-flag-cancel" onClick={onCancel}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction data-testid="delete-flag-confirm" onClick={onConfirm}>
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
